exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".se--base-view-container {\n  /* Hide the annoying scrollbar area that shows up. */\n  -ms-overflow-style: none;  /* Internet Explorer 10+ */\n  scrollbar-width: none;  /* Firefox */\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n", ""]);

